export const DEFAULT_COLORS: Record<string, string> = {
  primary: '#3b82f6',
  secondary: '#1e40af',
  accent: '#f59e0b',
  background: '#f8fafc',
  text: '#1f2937',
  stripLine: '#3b82f6',
  saveButton: '#3b82f6',
  companyBadge: '#8B2635',
};

const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export function normalizeHex(input?: string): string | null {
  if (!input) return null;
  const t = String(input).trim();
  const v = t.startsWith('#') ? t : `#${t}`;
  return HEX_RE.test(v) ? v : null;
}

export function resolveUserColors(userColors?: Record<string, string> | null): Record<string, string> {
  const out: Record<string, string> = { ...DEFAULT_COLORS };
  if (!userColors || typeof userColors !== 'object') return out;
  for (const [k, v] of Object.entries(userColors)) {
    const hex = normalizeHex(v as string);
    if (hex) out[k] = hex;
  }
  return out;
}
